/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = require('./db.json')



//////////////////
// WEBPACK FOOTER
// ./~/request/~/mime-db/index.js
// module id = 6AHt
// module chunks = 1